<script>
export default {
	name: "IndexHeaderStat",
	props: {
		value: {
			type: Number,
			default: 0
		},
		title: {
			type: String,
      required: true,
		},
    loading: Boolean
	},
  computed: {
    getTitle() {
      return this.title ?? this.$t('common.assets');
    },
  },
}
</script>

<template>
  <div class="inline-flex flex-col items-start justify-start px-4 relative">
    <small class="text-slate-400">{{ getTitle }}</small>

    <div v-if="loading" class="z-10 absolute inset-0 bg-surface-0/95 rounded-md flex items-center justify-center">
      <ProgressSpinner class=" h-6 w-6" :stroke-width="5"/>
    </div>

    <span :class="{'opacity-0': loading}" class="text-base font-bold">{{ value?.toLocaleString() || '-' }}</span>
  </div>
</template>

<style scoped>

</style>
